import PropTypes from 'prop-types';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SoftBadge from 'components/common/SoftBadge';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const OrderStatus = ({ status, className }) => {
  const { t } = useTranslation('commerce');
  return (
    <SoftBadge
      pill
      bg={classNames({
        success: status === 'completed',
        primary: status === 'processing',
        warning: status === 'pending',
        secondary: status === 'shipping'
      })}
      className={className}
    >
      {status === 'completed' && t('Completed')}
      {status === 'processing' && t('Processing')}
      {status === 'pending' && t('Pending')}
      {status === 'shipping' && t('Shipping')}
      <FontAwesomeIcon
        icon={classNames({
          check: status === 'completed',
          redo: status === 'processing',
          stream: status === 'pending',
          archive: status === 'shipping'
        })}
        transform="shrink-2"
        className="ms-1"
      />
    </SoftBadge>
  );
};

OrderStatus.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string
};

export default OrderStatus;
